// extracted by mini-css-extract-plugin
export default {"mergedCommentBlock":"index_mergedCommentBlock__HGlkQ","commentInput":"index_commentInput__8udxw","disabled":"index_disabled__ezTqg"};